import * as React from 'react';

import PropTypes from 'prop-types';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import PhoenixEnrollButton from 'bundles/certificate-enroll/components/PhoenixEnrollButton';
import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/ondemand';

type Props = {
  course: $TSFixMe;
  onClose: () => void;
};

class ContentRequiresEnrollModal extends React.Component<Props> {
  static childContextTypes = {
    course: PropTypes.object,
  };

  getChildContext() {
    const { course } = this.props;
    return {
      course,
    };
  }

  handleClose = () => {
    this.props.onClose();
  };

  render() {
    return (
      <div className="rc-ContentRequiresEnrollModal">
        <Modal
          type="layer"
          key="ContentRequiresEnrollModal"
          modalName="Join to access course content"
          handleClose={this.handleClose}
        >
          <h1>
            <FormattedMessage message={_t('Join {courseName}.')} courseName={this.props.course.get('name')} />
          </h1>
          <p>{_t('Enroll to access this course content.')}</p>
          <PhoenixEnrollButton />
        </Modal>
      </div>
    );
  }
}

export default ContentRequiresEnrollModal;
